// extracted by mini-css-extract-plugin
module.exports = {"container":"FromCloudTab_container__XDMGc","header":"FromCloudTab_header__3Jamn"};